/*
 * @Author: chenxuelai 2251702447@qq.com
 * @Date: 2023-07-05 09:21:29
 * @LastEditors: chenxuelai 2251702447@qq.com
 * @LastEditTime: 2023-09-01 17:21:36
 * @FilePath: /vue_huaqiang/src/api/upload.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import request from "@/utils/request";

export const getOssPolicy = (params: any) =>
  request({
    url: '/oss/policy',
    method: 'get',
    params
  })


export const upload = (url:string, data: FormData) =>
  request({
    headers: {"Content-Type": "multipart/form-data"},
    url: url,
    method: "post",
    data: data
  });

export const getOssAllUpload = (params: any) =>
  request({
    url: '/oss/sts-token',
    method: 'get',
    params
  })